import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=ac85f8d2&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"
import style0 from "./NotFound.scss?vue&type=style&index=0&id=ac85f8d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac85f8d2",
  null
  
)

export default component.exports